import { useEffect, useState } from "react";
import {
    Button,
    Col,
    Container,
    Row,
    TabContent,
    TabPane,
} from "reactstrap";

import {
    CoordinatorCustomer,
    CoordinatorGroup,
} from "../../Private/types/PrivateChat";

import PrivateChatService from "../../Private/Services/PrivateChatService";
import CoordinatorPrivateChat from "../../Private/Pages/CoordinatorPrivateChat";
import CoordinatorCustomerList from "../../Private/Components/CoordinatorCustomerList";
import CoordinatorGroupList from "../../Private/Components/CoordinatorGroupList";
import CoordinatorJoinRequestList from "../Components/CoordinatorJoinRequestList";
import MembersList from "../MembersList";
// eslint-disable-next-line
import GroupJoinRequestPage from "../GroupJoinRequestPage";
import GroupChatPage from "../../chat/page/GroupChatPage";

import "./CoordinatorHomePage.css";
import AppSettingsPage from "../../Pages/AppSettingsPage";
import CoordinatorLearningRequestPage from "../Components/CoordinatorLearningRequestPage";

const CoordinatorHomePage = () => {

    const [groups, setGroups] = useState<CoordinatorGroup[]>([]);
    const [customers, setCustomers] = useState<CoordinatorCustomer[]>([]);
    const [selectedGroup, setSelectedGroup] = useState<CoordinatorGroup>();
    const [selectedCustomer, setSelectedCustomer] =
        useState<CoordinatorCustomer>();
        const [showChat, setShowChat] = useState(false);

    const [activeTab, setActiveTab] = useState("group");

    useEffect(() => {
        loadGroups();
        // eslint-disable-next-line
    }, []);

    const loadGroups = async () => {
        const data = await PrivateChatService.getCoordinatorGroups();
        setGroups(data);

        if (data.length > 0) {
            selectGroup(data[0]);
        }
    };

    const selectGroup = async (group: CoordinatorGroup) => {

        setSelectedGroup(group);

        const data = await PrivateChatService.getCustomers(group.groupId);

        setCustomers(data);

        setSelectedCustomer(undefined);

        setActiveTab("group");
    };

    return (
        <Container fluid>

           <Row>

    {/* Group List */}

    <Col
        xs={12}
        md={2}
        className={`border-end ${showChat ? "d-none d-md-block" : ""} mt-4`}
    >
        <CoordinatorGroupList
            groups={groups}
            selectedGroup={selectedGroup?.groupId}
                        onSelect={selectGroup}
        />
    </Col>

    {/* Right Side */}

    <Col
        xs={12}
        md={10}
        className={`${!showChat ? "d-none d-md-block" : ""} mt-4`}
    >

        {/* Mobile Back Button */}

        <div className="d-md-none mb-3">
            <Button
                color="secondary"
                onClick={() => setShowChat(false)}
            >
                ← Back to Groups
            </Button>
        </div>

        {/* Tabs */}

        <div className="market-tabs mb-3">
            <Button
                color={activeTab === "group" ? "primary" : "light"}
                onClick={() => setActiveTab("group")}
                className="me-2 mb-2"
            >
                Group
            </Button>

            <Button
                color={activeTab === "group-chat" ? "primary" : "light"}
                onClick={() => setActiveTab("group-chat")}
                className="me-2 mb-2"
            >
                Group Chat
            </Button>

            <Button
                color={activeTab === "members" ? "primary" : "light"}
                onClick={() => setActiveTab("members")}
                className="me-2 mb-2"
            >
                Members
            </Button>

            <Button
                color={activeTab === "requests" ? "primary" : "light"}
                onClick={() => setActiveTab("requests")}
                className="me-2 mb-2"
            >
                Join Request
            </Button>

            <Button
                color={activeTab === "Group-settings" ? "primary" : "light"}
                onClick={() => setActiveTab("Group-settings")}
                className="me-2 mb-2"
            >
                Settings
            </Button>

            <Button
                color={activeTab === "learning" ? "primary" : "light"}
                onClick={() => setActiveTab("learning")}
                className="mb-2"
            >
                Group Location
            </Button>
        </div>

                    <TabContent activeTab={activeTab}>

                        {/* GROUP TAB */}

                        <TabPane tabId="group">

                            <Row>

                                <Col md={4}>

                                    <CoordinatorCustomerList
                                        customers={customers}
                                        selectedConversation={
                                            selectedCustomer?.conversationId
                                        }
                                        onSelect={setSelectedCustomer}
                                    />

                                </Col>

                                <Col md={8}>

                                    {selectedCustomer ? (

                                        <CoordinatorPrivateChat
                                            conversationId={
                                                selectedCustomer.conversationId
                                            }
                                            customerName={
                                                selectedCustomer.userName
                                            }
                                        />

                                    ) : (

                                        <div className="h-100 d-flex justify-content-center align-items-center">

                                            Select Customer

                                        </div>

                                    )}

                                </Col>

                            </Row>

                        </TabPane>

                        {/* MEMBERS */}

                        <TabPane tabId="members">

                            {selectedGroup && (

                                <MembersList
                                    groupId={selectedGroup.groupId}
                                />

                            )}

                        </TabPane>

                        {/* JOIN REQUEST */}

                        <TabPane tabId="requests">

                            {selectedGroup && (

                                <CoordinatorJoinRequestList />

                            )}

                        </TabPane>

                        {/* OLD JOIN REQUEST */}

                        <TabPane tabId="Group-settings">

                            {selectedGroup && (

                                <AppSettingsPage
                                    
                                />

                            )}

                        </TabPane>

                        {/* GROUP CHAT */}

                        <TabPane tabId="group-chat">

                            {selectedGroup && (

                                <GroupChatPage
                                    groupId={selectedGroup.groupId}
                                />

                            )}

                        </TabPane>

                        <TabPane tabId="learning">

    {selectedGroup && (

        <CoordinatorLearningRequestPage
            groupId={selectedGroup.groupId}
        />

    )}

</TabPane>

                    </TabContent>

                </Col>

            </Row>

        </Container>
    );
};

export default CoordinatorHomePage;